import { isNullOrWhitespace } from '@/helpers/stringHelper';

const getDefaultState = () => {
    return {
        SameAsShippingAddress: false,
        Type: 'national',
        ZipCode: null,
        Street: null,
        AddressLine2: null,
        Number: null,
        Complement: null,
        District: null,
        City: null,
        State: null,
        FetchedFields:[]
    };
};

export default {
    namespaced: true,

    state: () => getDefaultState(),

    getters: {
        getSubmitModel(state) {
            return {
                BillingAddress: {
                    ZipCode: state.ZipCode,
                    Street: state.Street,
                    District: state.District,
                    Number: state.Number,
                    Compl: state.Complement || state.AddressLine2,
                    City: state.City,
                    State: state.State,
                    IsBillingAddressSameAsShipping: state.SameAsShippingAddress
                }
            };
        },

        getSameAsShippingAddress: (state) => state.SameAsShippingAddress,

        getIsNational: (state) => state.Type == 'national'
    },

    mutations: {
        setSameAsShippingAddress(state, sameAsShippingAddress) {
            state.SameAsShippingAddress = sameAsShippingAddress;
        },
        setType(state, type) {
            this.commit('billingAddress/resetState');

            state.Type = type;
        },
        setZipCode: (state, zipCode) => state.ZipCode = zipCode,
        setStreet: (state, street) => state.Street = street,
        setAddressLine2: (state, addressLine2) => state.AddressLine2 = addressLine2,
        setNumber: (state, number) => state.Number = number,
        setComplement: (state, complement) => state.Complement = complement,
        setDistrict: (state, district) => state.District = district,
        setCity: (state, city) => state.City = city,
        setState: (state, _state) => state.State = _state,

        setFromGooglePay(state, billingAddress) {
            state.ZipCode = billingAddress.postalCode;
            state.Street = billingAddress.address1;
            state.AddressLine2 = billingAddress.address2;
            state.City = billingAddress.locality;
            state.State = billingAddress.administrativeArea;
        },

        setFromApplePay(state, billingAddress) {
            state.ZipCode = billingAddress.postalCode;
            state.City = billingAddress.locality;
            state.District = billingAddress.subLocality;
            state.State = billingAddress.administrativeArea.substring(0, 2);

            state.Street = billingAddress.addressLines[0];
            state.AddressLine2 = billingAddress.addressLines[1] || null;

            //Campos que não temos na resposta da apple pay
            // state.Number = null;
        },

        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            state.FetchedFields = [];
            if (!data) return;

            state.Street = data.Street;
            state.AddressLine2 = data.AddressLine2 || null;
            state.Number = data.Number || null;
            state.Complement = data.Complement || null;
            state.District = data.District;
            state.City = data.City;
            state.State = data.State;

            if(isNullOrWhitespace(state.Street) == false)
                state.FetchedFields.push('street');
            if(isNullOrWhitespace(state.District) == false)
                state.FetchedFields.push('district');
            if(isNullOrWhitespace(state.City) == false)
                state.FetchedFields.push('city');
            if(isNullOrWhitespace(state.State) == false)
                state.FetchedFields.push('state');
        },

        

        resetState(state) {
            Object.assign(state, getDefaultState());
        }
    },

    actions: {
        /**
         * Aplica reset no state quando o campo Zip Code for vazio
         */
        resetState({ commit }) {
            commit('billingAddress/resetState', null, { root: true });
        },

        setFromGooglePay({ commit }, billingAddress) {
            commit('setFromGooglePay', billingAddress);
        },

        setFromApplePay({ commit }, billingAddress) {
            commit('setFromApplePay', billingAddress);
        }
    }
};